import React from 'react';
import { useModalOverlayContentReady } from '../../contexts/ModalOverlayContext';

/** Wraps modal route content in the overlay layer and signals when the shell is mounted. */
const ModalOverlayEntry: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    useModalOverlayContentReady();
    return <>{children}</>;
};

export default ModalOverlayEntry;
